// src/context/CategoryContext.jsx
import { createContext, useState } from "react";

export const CategoryContext = createContext();

export const CategoryProvider = ({ children }) => {
  const [activeCategory, setActiveCategory] = useState("");
  const [activeBrand, setActiveBrand] = useState("");

  return (
    <CategoryContext.Provider value={{ activeCategory, setActiveCategory,activeBrand, 
        setActiveBrand }}>
      {children}
    </CategoryContext.Provider>
  );
};
